import{_ as e}from"../_baseGetTag-852b3600.js";import{i as r}from"../isObjectLike-964c2f40.js";import"../_commonjsHelpers-3a7f7302.js";var o=function(o){return"number"==typeof o||r(o)&&"[object Number]"==e(o)};export{o as isNumber};
//# sourceMappingURL=is-number.js.map
